import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';

const Travel = ({ width = 159, height = 136 }) => {
  const theme = useTheme();
  const colorPrimaryMain = theme.palette.primary.main;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 159 136"
    >
      <path
        fill="#E6E6E6"
        d="M21.884 35.194C7.55 43.93-.946 59.95.384 76.694 1.09 85.24 4.27 93.5 12.674 98c22.415 12 120.275 12.225 134.755-9 14.48-21.225 9.095-51.42-22.4-64-27.3-10.91-66.12-12.35-103.145 10.195z"
        opacity="0.3"
      ></path>
      <path
        stroke="#FFD200"
        strokeMiterlimit="10"
        d="M122.846 96.5V83.82a2.325 2.325 0 012.32-2.326h9.245a2.323 2.323 0 012.32 2.325V96.5"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        d="M122.846 96.5V83.82a2.325 2.325 0 012.32-2.326h9.245a2.323 2.323 0 012.32 2.325V96.5"
        opacity="0.08"
      ></path>
      <path
        fill="#FFD200"
        d="M60.63 66.37s-9.17 3.68-6.206 14.34c2.965 10.66 3.24 11.814 9.855 11.16 6.615-.656 2.33-11.16 2.33-11.16l-5.98-14.34z"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M57.184 33.46s-25.43 5.896-32.12 20.796l22.526 1.7 5.77-3.5 3.825-18.995z"
      ></path>
      <path
        fill="#fff"
        d="M57.184 33.46s-25.43 5.896-32.12 20.796l22.526 1.7 5.77-3.5 3.825-18.995z"
        opacity="0.46"
      ></path>
      <path
        fill="#E6E6E6"
        d="M81.21 135.596c42.548 0 77.04-2.649 77.04-5.915 0-3.267-34.492-5.915-77.04-5.915-42.548 0-77.04 2.648-77.04 5.915 0 3.266 34.492 5.915 77.04 5.915z"
        opacity="0.45"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M48.394 116.664s-2.225 1.61-4.27.455c-2.045-1.155-3.835.385-2.435 2.065s7.4 2.5 7.4 2.5l2.255-3.64-2.95-1.38zM88.54 123.781s.97 2.575 3.31 2.735c2.34.16 3 2.44.896 3.07-2.105.63-7.56-2-7.56-2l.13-4.285 3.225.48z"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M20.595 123.54s-5.295-1.45-6.445-6.375c0 0 8.205-1.66 8.435 6.81l-1.99-.435z"
        opacity="0.58"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M21.246 123s-3.7-5.85-.445-11.32c0 0 6.24 3.965 3.465 11.33l-3.02-.01z"
        opacity="0.73"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M22.2 122.999s1.95-6.175 7.86-7.345c0 0 1.104 4-3.826 7.365l-4.035-.02z"
      ></path>
      <path
        fill="#245B5B"
        d="M18.36 122.875l1.07 7.345 6.76.03.994-7.335-8.825-.04z"
      ></path>
      <path
        fill="#F4A28C"
        d="M59.1 20.386s.87 3.15 2.134 5a1.64 1.64 0 002.29.41c.915-.65 1.965-1.795 1.705-3.54l-.075-3a2.94 2.94 0 00-2.3-2.5C60.67 16.14 58.5 18.5 59.1 20.386z"
      ></path>
      <path
        fill="#F4A28C"
        d="M65.715 20.814l4.235 9.835-5.585 1.945-.84-7.934 2.19-3.846z"
      ></path>
      <path
        fill="#245B5B"
        d="M66.43 21.46a.31.31 0 01-.115.36 2.17 2.17 0 01-2.625-.05 2.726 2.726 0 01-1.04-2.8c-.86.524-1.78.947-2.74 1.26-.321.109-.66.163-1 .16l-1.64-2s-2.115-1.83-.945-2.836c1.17-1.005 2.38.305 3.055-1.22.675-1.525.77-2.035 2.135-1.86 1.365.175.415 1.56 2.265.85 1.85-.71 2.18.04 2.5.875.072.303.051.62-.06.91a10.05 10.05 0 00.21 6.35z"
      ></path>
      <path
        fill="#F4A28C"
        d="M63.33 21.8s-.415-1.186.5-1.426 1.53 1.5.385 2.08l-.885-.655zM59.75 22.34l-.416 1.5a.5.5 0 00.59.66l1.255-.215-1.43-1.945z"
      ></path>
      <path fill="#245B5B" d="M133.856 80.365h-8.18v2.65h8.18v-2.65z"></path>
      <path
        fill="#CE8172"
        d="M63.654 25.716s.72-.245 1.86-1.665c0 0 .525 2.075-1.63 4l-.23-2.335z"
        opacity="0.31"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M62.06 31.81l3.216-.58a45.395 45.395 0 004.46-1.04c5.5-1.57 21.685-5.264 26.29 4.1 5.58 11.346-3.735 48.15-3.735 48.15h-25.5s-5.205-15.33-12.645-24.81c-7.44-9.48-12.645-20.024 7.915-25.82z"
      ></path>
      <path
        fill="#000"
        d="M57.185 33.46s-1.28 8.16 9.93 2l-2.875-4a29 29 0 00-7.055 2z"
        opacity="0.08"
      ></path>
      <path
        fill="#F4A28C"
        d="M28.46 63.35c-5.08-1.58-5.84-8.5-1.235-11.184a12.6 12.6 0 015.45-1.6c8.54-.63 23.09-1.425 23.09-1.425s8.76 2.85 7.385 7.12-7.54-2.53-7.54-2.53-16.28 13-27.15 9.62z"
      ></path>
      <path
        fill="#245B5B"
        d="M55.872 48.597l-2.991.417.848 6.09 2.992-.416-.849-6.091z"
      ></path>
      <path
        fill="#FFD200"
        d="M55.877 47.87l-2.99.423.267 1.891 2.99-.423-.267-1.89z"
      ></path>
      <path
        fill="#F4A28C"
        d="M64.24 31.42s-3.88 3.57.605 4.334c4.485.766 4.89-5.564 4.89-5.564l-5.495 1.23z"
      ></path>
      <path
        fill="#245B5B"
        d="M66.815 82.44L47.59 116.663l4.965 3.455s10.62-17.725 23.265-26.63a3.192 3.192 0 014.86 1.635c3.42 10.575 3.71 29 3.71 29h5.86l2.04-41.67-25.475-.014z"
      ></path>
      <path
        fill="#000"
        d="M66.814 82.44s9.576-7.5 12.96-18.204a3.285 3.285 0 015.54-1.185l9.1 9.84 1.835-10.285-6.654-21.06-12.596-8.085-2.5 9.755-7.684 39.225z"
        opacity="0.08"
      ></path>
      <path
        fill="#FFD200"
        d="M62.68 72.97s5.906-5.86 7.056-25.43c.955-16.28 3.29-19.46 8.165-20.6 7.53-1.77 9.325.47 11.695 3.815 0 0-12.04.745-11.62 8.28.42 7.535-1.255 34.375-11.16 43.405 0 0-4.595-.385-4.135-9.47z"
      ></path>
      <path
        fill="#fff"
        d="M62.68 72.97s5.906-5.86 7.056-25.43c.955-16.28 3.29-19.46 8.165-20.6 7.53-1.77 9.325.47 11.695 3.815 0 0-12.04.745-11.62 8.28.42 7.535-1.255 34.375-11.16 43.405 0 0-4.595-.385-4.135-9.47z"
        opacity="0.46"
      ></path>
      <path
        fill="#F4A28C"
        d="M79.184 40.38c-2.5-6 4.465-13.57 10.5-11.23 5.16 2 10.675 6.42 13.67 15.32 7.115 21.155 23.145 31.38 23.145 31.38s8.18 1.35 8.18 4.325-9.67 0-9.67 0-25.1-10.415-38.12-27.15C83 48 80.61 43.795 79.184 40.38z"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M94.175 60.78s9.97-3.375 12.5-8.31c0 0-3.61-19.455-16.435-23.64-4.22-1.375-8.935.17-11.145 4-2.68 4.67-2.095 13.28 15.08 27.95z"
      ></path>
      <path
        fill="#fff"
        d="M94.175 60.78s9.97-3.375 12.5-8.31c0 0-3.61-19.455-16.435-23.64-4.22-1.375-8.935.17-11.145 4-2.68 4.67-2.095 13.28 15.08 27.95z"
        opacity="0.46"
      ></path>
      <path
        fill="#FFD200"
        d="M140.824 92.73h-22.08a2 2 0 00-2 2v29.765a2 2 0 002 2h22.08a2 2 0 002-2V94.731a2 2 0 00-2-2z"
      ></path>
      <path
        fill="#245B5B"
        d="M123.419 126.494h-3.185v3.185h3.185v-3.185zM138.9 126.494h-3.185v3.185h3.185v-3.185z"
      ></path>
      <path
        fill="#000"
        d="M124.695 99.006h-3.625v20.175h3.625V99.006zM131.6 99.006h-3.625v20.175h3.625V99.006zM138.086 99.006h-3.625v20.175h3.625V99.006z"
        opacity="0.08"
      ></path>
      <path
        fill="#245B5B"
        d="M92.29 21.405c5.81 0 10.52-4.71 10.52-10.52S98.1.365 92.29.365s-10.52 4.71-10.52 10.52 4.71 10.52 10.52 10.52z"
      ></path>
      <path
        fill="#245B5B"
        d="M88.22 10.885l-9 8.965 11.93-4.76-2.93-4.205z"
      ></path>
      <path
        fill="#fff"
        d="M92.905 6.15H91.15v5.54h1.755V6.15zM92.905 13.215H91.15v1.755h1.755v-1.755z"
      ></path>
    </svg>
  );
};

Travel.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Travel;
